import { render, staticRenderFns } from "./SPFreelancerRegistrationLayout.vue?vue&type=template&id=283e52ba&scoped=true"
import script from "./SPFreelancerRegistrationLayout.vue?vue&type=script&lang=js"
export * from "./SPFreelancerRegistrationLayout.vue?vue&type=script&lang=js"
import style0 from "./SPFreelancerRegistrationLayout.vue?vue&type=style&index=0&id=283e52ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283e52ba",
  null
  
)

export default component.exports